/* Love N Care — delivery offer messaging (cart drawer, cart page, PDP, flagship CTA).

   Mirrors the checkout rate service (shipping-rates-worker/src/pricing.js, live 30 Sep 2026):
     Sydney / Melbourne / Brisbane / Adelaide metro: live rate under $400, never more than $89
     from $400, free from $1,000.
     Everywhere else: live rate under $400; from $400, 40% off (never below $89) → "up to 40%".
   KEEP METRO_ZONES IN SYNC with pricing.js — checkout charges from that file, this only talks.

   <lnc-ship-offer data-ctx="drawer|cart|pdp|flag" data-cents="…"> renders itself on connect and
   whenever data-cents changes (PDP variant switch), so drawer re-renders (.lnc-shipbar replaceWith)
   need no re-init. The postcode is shared with the cart estimator (localStorage lnc-ship-estimate).

   CART CONTEXTS ARE POSTCODE-FIRST (5 Oct 2026, owner): no offer until we know the postcode — the
   bar is a postcode box. Once known, lnc-cart.js fetches Shopify's real rates and fires `lnc:rates`;
   the bar then shows the actual Standard price + only the offer that matters for that cart. The $89
   cap is only mentioned when this cart's delivery is over $89 (small carts ship for ~$10–40, and
   "capped at $89" read as "delivery costs $89+"). data-total must equal lnc-cart's data-total
   (cart.total_price) so a stale price is never shown after a cart change.

   LAUNCH OFFER (Oct 2026, window.LNC_LAUNCH from snippets/lnc-launch.liquid): Sydney, Melbourne & Brisbane
   metro ship FREE on every order and Adelaide is charged as "everywhere else" (pricing.js launch rules);
   the bag nudge also carries the Wabi nursery draw line (subscribe + spend $149 or more, after discounts). */
(function () {
  if (window.customElements.get('lnc-ship-offer')) return;

  var METRO_ZONES = {
    Sydney: [[2000, 2249], [2555, 2574], [2740, 2786]],
    Melbourne: [[3000, 3207], [3335, 3338], [3427, 3429], [3750, 3755], [3757, 3757], [3759, 3799], [3802, 3810], [3910, 3944], [3975, 3978]],
    Brisbane: [[4000, 4207], [4300, 4306], [4500, 4521]],
    Adelaide: [[5000, 5174]]
  };
  var CAP_FROM = 400, CAP = 89, FREE_FROM = 1000;
  /* Nudges only when they're close AND worth it (owner 5 Oct 2026: "Add $770 for free delivery" on a
     $13 delivery is noise). Otherwise just the price + the standard free-over-$1,000 line. */
  var NEAR_CAP = 100;        // within $100 of $400 → "add $X and it drops to $89" (only if delivery > $89)
  var NEAR_FREE = 250;       // within $250 of $1,000 → "add $X for free delivery"
  var MIN_FREE_SAVING = 25;  // …and only if free delivery saves at least $25
  var METRO_LABEL = 'Sydney, Melbourne, Brisbane & Adelaide metro';
  var LS_KEY = 'lnc-ship-estimate';
  var TRUCK = '<svg width="18" height="14" viewBox="0 0 20 15" fill="none" aria-hidden="true"><path d="M1 1.5h11v10H1zM12 5h4l3 3.5v3h-7" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="5" cy="12.7" r="1.6" fill="currentColor"/><circle cx="15.5" cy="12.7" r="1.6" fill="currentColor"/></svg>';
  var TICK = '<svg width="11" height="9" viewBox="0 0 11 9" fill="none" aria-hidden="true"><path d="M1 4.6l3 3L10 1.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var LAUNCH_ZONES = ['Sydney', 'Melbourne', 'Brisbane'];
  var GIFT = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/><path d="M12 7c-1.2-2.6-4.6-3.6-5.4-1.6C5.9 7.2 9.4 7.4 12 7zM12 7c1.2-2.6 4.6-3.6 5.4-1.6.7 1.8-2.8 2-5.4 1.6z"/></svg>';
  /* Early Black Friday Sale (client, 19 Oct 2026): from the sale start (20 Oct) checkout is plain live rates for
     good — the metro $89 cap / free-over-$1,000 and regional offers are gone. <html>.lnc-live-rates (snippets/lnc-sale)
     turns every offer line off; the bag's delivery row (lnc-cart.js) still shows the real price. */
  function liveRates() { return document.documentElement.classList.contains('lnc-live-rates'); }
  function launchOn() { // <html>.lnc-launch-on is set from the launch dates in layout/theme.liquid
    return !!window.LNC_LAUNCH && document.documentElement.classList.contains('lnc-launch-on');
  }
  function metroZone(zip) {
    var n = parseInt(zip, 10);
    if (!n) return null;
    for (var zone in METRO_ZONES) {
      if (METRO_ZONES[zone].some(function (r) { return n >= r[0] && n <= r[1]; })) {
        // during the launch only Sydney, Melbourne & Brisbane are metro (Adelaide pays "everywhere else" rates)
        return launchOn() && LAUNCH_ZONES.indexOf(zone) === -1 ? null : zone;
      }
    }
    return null;
  }
  function getZip() {
    try { var s = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); return s && /^[0-9]{4}$/.test(s.zip) ? s.zip : ''; } catch (e) { return ''; }
  }
  function setZip(zip) {
    try { localStorage.setItem(LS_KEY, JSON.stringify({ zip: zip })); } catch (e) { /* private mode: this page view only */ }
    window.__lncShipZip = zip;
    RATES = null;
    renderAll();
    document.dispatchEvent(new CustomEvent('lnc:postcode', { detail: { zip: zip, source: 'offer' } }));
  }
  var RATES = null; // { zip, total, std (cents|null), none: bool, error: bool }
  /* Product-page estimates: this item to the shopper's postcode, same rules as checkout. */
  var ESTIMATE_URL = 'https://lnc-shipping-rates.square-voice-ee10.workers.dev/estimate';
  var ESTIMATES = {}; // 'pid|cents|zip' -> { state: 'loading'|'done'|'fail', data }
  /* What's already in the bag, so a product page can say "your whole order ships free" when this item
     tips a metro order over $1,000. Refreshed on load and whenever the cart's rates reload. */
  var CART = null; // { cents, ids: [product ids] }
  function loadCart() {
    if (!document.querySelector('lnc-ship-offer[data-product-id]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      CART = { cents: c.original_total_price || c.total_price || 0, ids: (c.items || []).map(function (i) { return String(i.product_id); }) };
      renderAll();
    }).catch(function () {});
  }
  function estimateFor(pid, cents, zip) {
    var key = pid + '|' + cents + '|' + zip;
    if (ESTIMATES[key]) return ESTIMATES[key];
    try { var hit = JSON.parse(sessionStorage.getItem('lnc-est:' + key) || 'null'); if (hit) return (ESTIMATES[key] = { state: 'done', data: hit }); } catch (e) {}
    ESTIMATES[key] = { state: 'loading' };
    fetch(ESTIMATE_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ product_id: String(pid), cents: cents, postcode: zip }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        ESTIMATES[key] = d && d.ok ? { state: 'done', data: d } : { state: 'fail' };
        if (d && d.ok) { try { sessionStorage.setItem('lnc-est:' + key, JSON.stringify(d)); } catch (e) {} }
        renderAll();
      })
      .catch(function () { ESTIMATES[key] = { state: 'fail' }; renderAll(); });
    return ESTIMATES[key];
  }
  function money(dollars) {
    var whole = Math.abs(dollars - Math.round(dollars)) < 0.005;
    return '$' + dollars.toLocaleString('en-AU', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Copy for each state. Returns { tone, head, sub, track } — track only for cart contexts. */
  function cartView(t, zip, zone, rates) {
    if (!zip) {
      return { tone: 'ask', head: 'See your delivery price', sub: liveRates() ? 'Enter your postcode for your exact delivery cost.' : 'Enter your postcode for your exact delivery cost and any offers for your area.', form: true };
    }
    if (!rates) return { tone: 'progress', head: 'Delivery to ' + esc(zip), sub: 'Checking your price…' };
    if (rates.none) return { tone: 'progress', head: 'Sorry, we can’t deliver to ' + esc(zip), sub: 'Call 1300 732 599 and we’ll help.' };
    var s = rates.std == null ? null : rates.std / 100;
    var price = s == null ? '' : (s === 0 ? 'Free' : money(s));
    var head = s == null ? 'Delivery to ' + esc(zip) : (s === 0 ? 'Free delivery to ' + esc(zip) : 'Delivery to ' + esc(zip) + ': ' + price);
    if (liveRates()) return { tone: 'progress', head: head, sub: '' };
    var toCap = CAP_FROM - t, toFree = FREE_FROM - t;
    if (zone) {
      if (t >= FREE_FROM) return { tone: 'done', head: 'Free delivery to ' + esc(zip), sub: zone + ' metro · your order qualifies for free delivery.' };
      var standardLine = 'Free metro delivery on orders over $1,000.';
      var capped = t >= CAP_FROM && s != null && s >= CAP - 0.005;
      // close to $1,000 and free delivery is a real saving
      if (s != null && toFree <= NEAR_FREE && s >= MIN_FREE_SAVING) {
        return { tone: 'progress', head: head,
          sub: (capped ? 'Capped at $89 with our ' + zone + ' metro offer. ' : '') + 'Add ' + money(toFree) + ' for free delivery (save ' + money(s) + ').',
          track: { value: t, from: FREE_FROM - NEAR_FREE, to: FREE_FROM, marks: [[1, '$1,000', 'free', false]] } };
      }
      // under $400, close to it, and this cart's delivery is over $89 → the cap actually helps
      if (t < CAP_FROM && s != null && s > CAP && toCap <= NEAR_CAP) {
        return { tone: 'progress', head: head,
          sub: 'Add ' + money(toCap) + ' and your delivery drops to $89 (save ' + money(s - CAP) + ').',
          track: { value: t, from: CAP_FROM - NEAR_CAP, to: CAP_FROM, marks: [[1, '$400', 'max $89', false]] } };
      }
      return { tone: 'progress', head: head, sub: (capped ? 'Capped at $89 with our ' + zone + ' metro offer. ' : '') + standardLine };
    }
    // everywhere else: $89+ over $400 means the 40%-off/$89-minimum rule applied
    if (t >= CAP_FROM) return { tone: 'progress', head: head, sub: s != null && s >= CAP - 0.005 ? 'Includes up to 40% off with our regional offer.' : '' };
    if (s != null && s > CAP && toCap <= NEAR_CAP) {
      return { tone: 'progress', head: head, sub: 'Add ' + money(toCap) + ' to save up to 40% on delivery.',
        track: { value: t, from: CAP_FROM - NEAR_CAP, to: CAP_FROM, marks: [[1, '$400', 'up to 40% off', false]] } };
    }
    return { tone: 'progress', head: head, sub: s != null && s > CAP ? 'Orders over $400 save up to 40% on delivery.' : '' };
  }

  /* Product page + flagship CTA — a slim row AFTER the buy buttons (owner 5 Oct 2026). Before a postcode it
     asks for one (inline box) with the offer for this price band; after, it shows THIS item's real Standard
     price to that postcode (/estimate), plus the saving when an offer applies. */
  function productView(t, zip, zone, est, pid) {
    var offer = t >= FREE_FROM ? 'Free metro delivery on this item.' : t >= CAP_FROM ? 'Metro delivery capped at $89 on this item.' : 'Orders over $400 get hugely discounted delivery.';
    if (!zip) return { tone: 'row', head: 'Check delivery to your postcode', sub: offer, form: true };
    if (!est || est.state === 'loading') return { tone: 'row', head: 'Delivery to ' + esc(zip) + ': checking…', sub: '' };
    if (est.state === 'fail') return { tone: 'row', head: 'Delivery to ' + esc(zip), sub: 'Your exact delivery price shows in your bag.' };
    var d = est.data;
    if (d.none) return { tone: 'row', head: 'Sorry, we can’t deliver to ' + esc(zip), sub: 'Call 1300 732 599 and we’ll help.' };
    if (zone && CART && CART.cents > 0 && t < FREE_FROM) { // only when the bag is what tips it over $1,000
      var inBag = CART.ids.indexOf(String(pid)) !== -1;
      var orderCents = inBag ? CART.cents : CART.cents + Math.round(t * 100);
      if (orderCents >= FREE_FROM * 100) return { tone: 'row', head: 'Free delivery to ' + esc(zip),
        sub: inBag ? 'Your whole order qualifies for free ' + zone + ' metro delivery.' : 'With what’s already in your bag, your whole order ships free.' };
    }
    var head = d.standard === 0 ? 'Free delivery to ' + esc(zip) : 'Delivery to ' + esc(zip) + ': ' + money(d.standard / 100);
    var saved = (d.live || 0) - d.standard;
    var save = saved >= 100 ? ' (save ' + money(saved / 100) + ')' : '';
    var sub = '';
    if (d.band === 'metro-free') sub = 'Free with our ' + d.zone + ' metro offer' + save + '.';
    else if (d.band === 'metro-capped' && saved >= 100) sub = 'Capped at $89 with our ' + d.zone + ' metro offer' + save + '.';
    else if (d.band === 'regional-discount' && saved >= 100) sub = 'Includes our regional offer' + save + '.';
    else if (t < CAP_FROM && d.standard > CAP * 100) sub = 'Orders over $400 get hugely discounted delivery.';
    if (d.eta) sub = (sub ? sub + ' ' : '') + 'Est. ' + d.eta + '.';
    return { tone: 'row', head: head, sub: sub };
  }

  function trackHtml(tr) {
    // the track covers only the last stretch before the threshold (e.g. $750 → $1,000), so a close nudge reads as nearly there
    var pct = tr.to != null ? Math.max(4, Math.min(100, (tr.value - tr.from) / (tr.to - tr.from) * 100)) : Math.max(0, Math.min(1, tr.pct)) * 100;
    return '<div class="lnc-sof__track" role="presentation"><span class="lnc-sof__fill" style="width:' + pct.toFixed(1) + '%"></span>' +
      tr.marks.map(function (mk) { return '<span class="lnc-sof__notch' + (mk[3] ? ' is-hit' : '') + '" style="left:' + (mk[0] * 100) + '%"></span>'; }).join('') + '</div>' +
      '<div class="lnc-sof__marks">' + tr.marks.map(function (mk) {
        return '<span class="lnc-sof__mark' + (mk[3] ? ' is-hit' : '') + (mk[0] === 1 ? ' is-end' : '') + '" style="left:' + (mk[0] * 100) + '%">' + (mk[3] ? TICK + ' ' : '') + '<b>' + mk[1] + '</b> ' + mk[2] + '</span>';
      }).join('') + '</div>';
  }

  class LncShipOffer extends HTMLElement {
    static get observedAttributes() { return ['data-cents']; }
    connectedCallback() { this.render(); }
    attributeChangedCallback() { if (this.isConnected) this.render(); }
    render() {
      var ctx = this.dataset.ctx || 'drawer';
      var cart = ctx === 'drawer' || ctx === 'cart' || ctx === 'nudge';
      var t = (parseInt(this.dataset.cents, 10) || 0) / 100;
      var zip = window.__lncShipZip !== undefined ? window.__lncShipZip : getZip();
      var zone = zip ? metroZone(zip) : null;
      var total = parseInt(this.dataset.total, 10);
      var rates = RATES && RATES.zip === zip && (isNaN(total) || RATES.total === total) ? RATES : null;
      if (cart && zip && !rates) this.armTimeout(zip);
      if (rates && rates.error) rates = { zip: zip, std: null };
      var pid = this.dataset.productId;
      var est = !cart && zip && pid ? estimateFor(pid, parseInt(this.dataset.cents, 10) || 0, zip) : null;
      var v = cart ? cartView(t, zip, zone, rates) : productView(t, zip, zone, est, pid);
      // 'nudge' (6 Oct 2026): one quiet line in the bag/cart footer, ONLY when close to $400/$1,000 and worth it.
      // The delivery price itself is shown by the footer's delivery row (lnc-cart.js), so nothing else here.
      if (ctx === 'nudge' && liveRates()) { this.hidden = true; this.innerHTML = ''; return; }
      if (ctx === 'nudge' && launchOn()) {
        // Launch: at most two short lines — the free-metro confirmation (only once Shopify's rate says $0) or
        // the regional offer as usual, then the draw line, which counts the bag total after discounts.
        // (Metro "free delivery" needs no extra line: the delivery row above already says "Free delivery".)
        // Owner 7 Oct: keep it to one compact strip — prize + value on top, this bag's status + one action below.
        var L = window.LNC_LAUNCH, lines = [];
        if (zip && rates && !zone && v.sub && (v.track || /regional offer/i.test(v.sub))) {
          lines.push('<p class="lnc-sof__nudge">' + v.sub + '</p>');
        }
        var paid = isNaN(total) ? Math.round(t * 100) : total, min = (L.min || 149) * 100;
        var subscribed = !!L.subscribed;
        try { subscribed = subscribed || localStorage.getItem('lnc-lpop') === 'subscribed'; } catch (e) {}
        if (paid > 0) {
          var status = paid < min ? 'Add ' + money((min - paid) / 100) + ' to qualify'
            : subscribed ? '<span class="lnc-sof__ok">' + TICK + 'You’re subscribed — check out to enter</span>'
            : '<span class="lnc-sof__ok">' + TICK + 'Your bag qualifies</span> · <button type="button" class="lnc-sof__signup" data-lnc-lpop-open>Enter now</button>';
          lines.push('<div class="lnc-sof__draw"><span class="lnc-sof__gift">' + GIFT + '</span><span class="lnc-sof__drawtext">' +
            '<b>Win a Wabi nursery valued at $1,699.98</b><span class="lnc-sof__drawsub">' + status + '</span></span></div>');
        }
        this.className = 'lnc-sof lnc-sof--nudge lnc-sof--launch';
        this.hidden = !lines.length;
        this.innerHTML = lines.join('');
        return;
      }
      if (ctx === 'nudge') {
        var done = !!(zip && rates && v.tone === 'done');
        // show: free unlocked, a close-and-worth-it nudge, or an offer that IS applied (cap / regional discount);
        // never the generic "Free metro delivery on orders over $1,000." line
        var applied = !!(v.sub && /Capped at \$89|regional offer/i.test(v.sub));
        var show = done || !!(zip && rates && v.sub && (v.track || applied));
        this.className = 'lnc-sof lnc-sof--nudge' + (done ? ' is-done' : '');
        this.hidden = !show;
        this.innerHTML = !show ? '' : done
          ? '<p class="lnc-sof__nudge"><span class="lnc-sof__tick">' + TICK + '</span>Free delivery unlocked with our ' + zone + ' metro offer.</p>'
          : '<p class="lnc-sof__nudge">' + v.sub + '</p>';
        return;
      }
      var editing = this._editing || v.form;
      var where = zip
        ? 'Delivering to <b>' + esc(zip) + '</b>' + (zone ? ' · ' + zone + ' metro' : '') + ' <button type="button" class="lnc-sof__link" data-so-edit>Change</button>'
        : '<button type="button" class="lnc-sof__link" data-so-edit>Check your postcode</button>';
      if (zip) where = '<button type="button" class="lnc-sof__link" data-so-edit>Change postcode</button>';
      // NOT a <form>: on /cart this sits inside the cart's own form, where a nested form is dropped by the
      // parser and "Check" submitted the whole cart (page reload, postcode lost). Enter/click handled below.
      var form = '<div class="lnc-sof__form" data-so-form role="group" aria-label="Check delivery to your postcode"><input class="lnc-sof__input" name="zip" type="text" inputmode="numeric" pattern="[0-9]{4}" maxlength="4" autocomplete="postal-code" placeholder="Postcode" aria-label="Your postcode" value="' + esc(zip) + '"><button type="button" class="lnc-sof__go" data-so-go>Check</button><span class="lnc-sof__err" data-so-err hidden>Enter a 4-digit postcode</span></div>';

      this.className = 'lnc-sof lnc-sof--' + ctx + ' lnc-sof--' + v.tone;
      this.innerHTML =
        '<div class="lnc-sof__main">' +
          (cart ? '' : '<span class="lnc-sof__icon">' + TRUCK + '</span>') +
          '<div class="lnc-sof__text">' +
            '<p class="lnc-sof__head">' + (cart && v.tone === 'ask' ? '<span class="lnc-sof__ticon">' + TRUCK + '</span>' : '') + (v.tone === 'done' ? '<span class="lnc-sof__tick">' + TICK + '</span>' : '') + v.head + '</p>' +
            (v.sub ? '<p class="lnc-sof__sub">' + v.sub + '</p>' : '') +
            (cart && v.track ? trackHtml(v.track) : '') +
            (editing ? form : '<p class="lnc-sof__where">' + where + '</p>') +
          '</div>' +
        '</div>';
      // Select the old postcode so typing replaces it (maxlength 4 otherwise swallows every keystroke).
      if (this._editing) { var inp = this.querySelector('.lnc-sof__input'); if (inp) { inp.focus(); try { inp.select(); } catch (e) {} } }
    }
    /* No rates (empty cart elsewhere, Shopify slow) → after 12 s show the postcode's offer without a price. */
    armTimeout(zip) {
      var self = this;
      if (this._waitFor === zip) return;
      this._waitFor = zip;
      setTimeout(function () {
        if (!RATES || RATES.zip !== zip) { RATES = { zip: zip, total: parseInt(self.dataset.total, 10), std: null, error: true }; renderAll(); }
      }, 12000);
    }
  }
  customElements.define('lnc-ship-offer', LncShipOffer);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadCart); else loadCart();
  function renderAll() { document.querySelectorAll('lnc-ship-offer').forEach(function (el) { el.render(); }); }

  /* Real rates from lnc-cart.js (Shopify cart estimate = what checkout charges). */
  document.addEventListener('lnc:rates', function (e) {
    var d = e.detail || {};
    var std = null;
    if (d.rates && d.rates.length) {
      var st = d.rates.filter(function (r) { return /standard/i.test(r.name); })[0] ||
        d.rates.slice().sort(function (a, b) { return a.cents - b.cents; })[0];
      std = st.cents;
    }
    RATES = { zip: d.zip, total: d.total, std: std, none: !!(d.rates && !d.rates.length), error: !d.rates };
    loadCart(); // the bag changed (or its rates reloaded) — keep product-page wording in step
    renderAll();
  });

  document.addEventListener('click', function (e) {
    var edit = e.target.closest && e.target.closest('[data-so-edit]');
    if (!edit) return;
    var el = edit.closest('lnc-ship-offer');
    el._editing = true;
    el.render();
  });
  function submitBox(box) {
    var zip = ((box.querySelector('.lnc-sof__input') || {}).value || '').trim();
    if (!/^[0-9]{4}$/.test(zip)) { box.querySelector('[data-so-err]').hidden = false; return; }
    var el = box.closest('lnc-ship-offer');
    el._editing = false;
    setZip(zip);
  }
  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-so-go]');
    if (go) { e.preventDefault(); submitBox(go.closest('[data-so-form]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-so-form] .lnc-sof__input');
    if (input) { e.preventDefault(); e.stopPropagation(); submitBox(input.closest('[data-so-form]')); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var el = e.target.closest && e.target.closest('lnc-ship-offer');
    if (el && el._editing) { el._editing = false; el.render(); }
  });
  /* Postcode typed into the cart's delivery options (lnc-cart.js) → refresh the messaging. */
  document.addEventListener('lnc:postcode', function (e) {
    var d = e.detail || {};
    if (d.source === 'offer') return;
    window.__lncShipZip = /^[0-9]{4}$/.test(d.zip || '') ? d.zip : undefined;
    RATES = null;
    renderAll();
  });
  /* …or in another tab. */
  window.addEventListener('storage', function (e) {
    if (e.key === LS_KEY) { window.__lncShipZip = undefined; document.querySelectorAll('lnc-ship-offer').forEach(function (el) { el.render(); }); }
  });
})();
